import Address from "@/classes/global/Address";
import ContactDetail from "@/classes/bookings/ContactDetail";

export default class Quote {

    constructor() {

        this.shipperDetail = {

            isShipperAddress: true,
            selectedCompany: new Address(),
            newCompany: new Address(),
            newContact: new ContactDetail(),
            confirmSaveCompany: false,
            confirmUpdateCompany: false,
            companyCopy: {},
            keepExistingContacts: true,
            isUpdate: false,
            updateContactDropDown: true,

            openNewCompanyModal: false,
            openEditCompanyModal: false,
            openNewContactModal: false,
            openEditContactModal: false,
            companyList: [],
            validatedFields: [],
            countries: []

        }

        this.consigneeDetail = {

            isShipperAddress: false,
            selectedCompany: new Address(),
            newCompany: new Address(),
            newContact: new ContactDetail(),
            confirmSaveCompany: false,
            confirmUpdateCompany: false,
            companyCopy: {},
            isUpdate: false,
            updateContactDropDown: true,

            openNewCompanyModal: false,
            openEditCompanyModal: false,
            openNewContactModal: false,
            openEditContactModal: false,
            companyList: [],
            validatedFields: [],
            countries: []

        }

    }
}